/**
 * Where to go after signing in. The login page carries the page the guard
 * bounced the user from as `?redirect=`, which anyone can craft into a link —
 * so only an in-app path is followed (`/…`, never `//evil.example` or
 * `https://…`), and anything else lands on the home page.
 */
export const HOME_PATH = '/rundowns';

export function safeRedirect(raw: unknown): string {
  if (typeof raw !== 'string' || !raw.startsWith('/') || raw.startsWith('//') || raw.startsWith('/\\')) return HOME_PATH;
  if (raw === '/login' || raw.startsWith('/login?') || raw.startsWith('/login/')) return HOME_PATH;
  return raw;
}

/**
 * The route guard's decision (app/router.tsx): signed out, bounce to the login
 * page carrying where the user was going; signed in, stay (null).
 */
export function guardAuthed(session: unknown, href: string): { readonly to: '/login'; readonly search: { readonly redirect: string } } | null {
  return session === null ? { to: '/login', search: { redirect: href } } : null;
}
